import { SAVED_COURSES_TRANSLATION_KEY } from "../constants.js";
const translation = {
    [SAVED_COURSES_TRANSLATION_KEY]: {
        SC_BOOKMARK_REMOVED_COURSE: 'Curso removido de "Meus salvos"',
        SC_BOOKMARK_ADDED_COURSE: 'Curso salvo em "Meus salvos"',
        SC_ERROR_SAVE_COURSE: "Falha ao salvar o curso, tente novamente mais tarde",
        SC_ERROR_DELETE_COURSE: "Falha ao excluir o curso, tente novamente mais tarde"
    }
};
const pt = translation;
export default pt;
